<template>
  <div class="container">
    <div class="row">
      <div class="content-wrap">
        <div class="search-wrap">
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <ElLabel name="회계년도">
                  <template #end>
                    <DatePicker
                      v-model="state.searchParams.fs_year"
                      :format="state.format"
                      :year-picker="true"
                      :selectDate="state.searchParams.fs_year"
                      @return="r=>state.searchParams.fs_year = r"
                    />
                  </template>
                </ElLabel>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <ElLabel name="영업대표">
                <template #end>
                  <ElSelect v-model="state.searchParams.sales_ceo" :options="state.ceoList" />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>

        <div class="search-detail-wrap"></div>
        <div class="text-end py-2">
          <ElButton type="search" @buttonClick="search()">검색</ElButton>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <div></div>
          <div class="table-btn-group d-flex align-items-center">
            <ElButton type="excelDownload" @buttonClick="excelDownload()">엑셀다운</ElButton>
          </div>
        </div>

        <Splitter layout="vertical" style="height: 65rem">
          <SplitterPanel :size="75">
            <!-- <div class="table-responsive" style="height: 100%"> -->
              <div ref="tableHeader" class="table-responsive" style="height: 100%">
                <table class="table table-rt table-hover">
                  <thead class="fh-top">
                    <tr class="tr-rt">
                      <th
                        ref="firstTableHeader"
                        :class="col.thClass"
                        v-for="(col) in gridOptions.column"
                      >
                        <div v-if="col.class2" :class="col.class2">
                          <span>{{ col.header }}</span>
                          <span v-if="col.sfont" :class="col.sfont">{{ col.sfontVal }}</span>
                        </div>
                        <span v-else>{{ col.header }}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="gridOptions.value && gridOptions.value.length > 0">
                      <tr v-for="(row) in gridOptions.value" :key="'val1-' + row.class_nm">
                        <td
                          v-for="(col, colIndex) in gridOptions.column"
                          :key="colIndex"
                          :class="getClassNm(row, colIndex)"
                        >
                          <div v-if="colIndex === gridOptions.column.length - 2">
                            <span :class="valueByClass(row[col.field], colIndex)"></span>
                          </div>
                          <span v-else :class="valueByClass(row[col.field], colIndex)">
                            {{ numberFormat(row[col.field], colIndex) }}
                          </span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div v-if="!gridOptions.value || gridOptions.value.length === 0"> 조회된 데이터가 없습니다.</div>
              </div>
            <!-- </div> -->
          </SplitterPanel>
          <SplitterPanel :size="25">
            <div class="table-responsive" ref="tableBody" style="height: 100%;">
              <table class="table table-rt table-hover">
                <thead class="fh-top">
                  <tr class="tr-rt">
                    <th
                      ref="firstTableHeader"
                      :class="col.thClass"
                      v-for="(col) in gridOptions.column2"
                    >
                      <div v-if="col.class2" :class="col.class2">
                        <span>{{ col.header }}</span>
                        <span v-if="col.sfont" :class="col.sfont">{{ col.sfontVal }}</span>
                      </div>
                      <span v-else>{{ col.header }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="gridOptions.value2 && gridOptions.value2.length > 0">
                    <tr v-for="(row) in gridOptions.value2" :key="'val2-' + row.class_nm" class="value2-row">
                      <td
                        v-for="(col, colIndex) in gridOptions.column2"
                        :key="colIndex"
                        :class="getClassNm(row, colIndex)"
                        :style="colIndex === 0 ? { minWidth: firstTableHeaderWidth + 'px' } : null"
                      >
                        <div v-if="colIndex === gridOptions.column.length - 2">
                          <span :class="valueByClass(row[col.field], colIndex)"></span>
                        </div>
                        <span v-else :class="valueByClass(row[col.field], colIndex)">
                          {{ numberFormat(row[col.field], colIndex) }}
                        </span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div v-if="!gridOptions.value2 || gridOptions.value2.length === 0">조회된 데이터가 없습니다.</div>
            </div>
          </SplitterPanel>
        </Splitter>
      </div>
    </div>
  </div>
  <ExcelManage ref="excelManageRef" v-show="false" />
</template>

<script setup>
import { onBeforeMount,ref,reactive,onMounted,nextTick, onUnmounted, watch } from 'vue';
import { getPerformanceFCSTList,getPerformanceTotalList } from '@/api/monthly';
import { getLoadUsers } from '@/api/monthly';
import common from "@/js/common";
import DatePicker from '@/components/common/DatePicker.vue';
import ExcelManage from '@/components/common/MCO_EX_001.vue'
import { useLoading } from '@/composable/Loading'
const { setIsLoading } = useLoading()
import { useUserStore } from "@/store/user";
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
const userStore = useUserStore()
const yearsList = ref([]);
const excelManageRef = ref()

const tableHeader = ref(null);
const tableBody = ref(null);
const firstTableHeader = ref(null);

const firstTableHeaderWidth = ref(0);

onBeforeMount(async()=>{
  await getSalesCeo()
  getYearsList();


  await getDataList()
  await getPerformanceTotal();
})

onMounted(() => {
  observeTableHeader();


  tableBody.value.addEventListener('scroll', () => {
    if (tableHeader.value) tableHeader.value.scrollLeft = tableBody.value.scrollLeft;
  });
  tableHeader.value.addEventListener('scroll', () => {
    if (tableBody.value) tableBody.value.scrollLeft = tableHeader.value.scrollLeft;
  });
});


let observer = null;
const syncColumnWidth = () => {
  requestAnimationFrame(() => {
    nextTick(() => {
      if (firstTableHeader.value && firstTableHeader.value[0]) {
        const width = firstTableHeader.value[0].getBoundingClientRect().width;
        if (width > 0 && firstTableHeaderWidth.value !== width) {
          firstTableHeaderWidth.value = width;

        }

      }
    });
  });
};

const observeTableHeader = () => {
  if (!firstTableHeader.value || !firstTableHeader.value[0]) {

    setTimeout(observeTableHeader, 100);
    return;
  }


  observer = new ResizeObserver(() => {
    syncColumnWidth();
  });

  observer.observe(firstTableHeader.value[0]);

  syncColumnWidth();
};

onUnmounted(() => {
  if (observer && firstTableHeader.value && firstTableHeader.value[0]) {
    observer.unobserve(firstTableHeader.value[0]);
  }

});

const gridOptions = ref({
  value : [],
  rows : 20,
  rowsPerPageOptions : [10, 20, 50, 100,200],
  column : [
    {header : 'Product', field : 'prod_nm',thClass : 'table-item'},
    {header : 'Quota', field : 'qty_sum',thClass : 'thbg-01'},
    {header : 'Commit', field : 'commitsum',thClass : 'thbg-02',class2:'th-rt',sfont:'th-sfont',sfontVal : 'A'},
    {header : 'Won', field : 'wonsum',thClass : 'thbg-02' ,class2:'th-rt',sfont:'th-sfont',sfontVal : '(B)'},
    {header : 'Close', field : 'closesum',thClass : 'thbg-02',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C)'},
    {header : 'Revenue', field : 'closetaxnsum',thClass : 'thbg-03',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-1, Invoice - No)'},
    {header : 'Revenue', field : 'closetaxysum',thClass : 'thbg-04',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-2, Invoice - Yes)'},
    {header : 'Revenue Perf(%)', field : 'perf1',thClass:'qt thbg-04',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-2)'},

    {header : 'Revenue Perf(%)', field : 'perf2',thClass:'qt thbg-05',class2:'th-rt',sfont:'th-sfont',sfontVal : '(Close)'},
    {header : 'FCST', field : 'fcstabc',thClass : 'thbg-06',class2:'th-rt',sfont:'th-sfont',sfontVal : '(A,B,C)'},
    {header : 'FCST(%)', field : 'fcstper',thClass : 'thbg-06',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'FCST Delta to Prior Week',thClass : 'thbg-07', field : 'fcstabc_sub'},
    {header : 'GM', field : 'gmamt',thClass : 'thbg-08'},
    {header : 'GM(%)', field : 'gmamtper',thClass : 'thbg-08',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'GM Delta to Prior Week',thClass : 'thbg-07', field : 'gmamt_sub'},
    {header : 'To go', field : 'togofcstquota',thClass : 'thbg-09',class2:'th-rt',sfont:'th-sfont',sfontVal : '(FCST vs Quota)'},
    {header : 'Risk', field : 'riskvaluesum',thClass : 'thbg-10'},
    {header : 'Bridge', field : 'bridgevaluesum',thClass : 'thbg-10'},
    {header : 'FCST-Risk+Bridge', field : 'fcstriskbridgesum',thClass : 'thbg-11'},
    {header : 'FCST-Risk+Bridge(%)', field : 'fcstriskbridgeper',thClass:'tt thbg-11',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'To go', field : 'togofcstriskbridgeper',thClass : 'thbg-12',class2:'th-rt',sfont:'th-sfont',sfontVal : '(FCST-Risk+Bridge vs Quota)'},
    {header : 'Upside', field : 'upsidevaluesum',thClass : 'thbg-10'},
    {header : 'Pipeline', field : 'pipelinevaluesum',thClass : 'thbg-13'},
    {header : 'Pipeline Size', field : 'pipelinesizeper',thClass : 'thbg-03'},
    {header : 'Pipeline Size per', field : 'pipelinesizeper',thClass : 'thbg-03'},
  ],
  column2 : [
    {header : '날짜', field : 'friday_date',thClass : 'table-item'},
    {header : 'Quota', field : 'qty_sum',thClass : 'thbg-01'},
    {header : 'Commit', field : 'commitsum',thClass : 'thbg-02',class2:'th-rt',sfont:'th-sfont',sfontVal : 'A'},
    {header : 'Won', field : 'wonsum',thClass : 'thbg-02' ,class2:'th-rt',sfont:'th-sfont',sfontVal : '(B)'},
    {header : 'Close', field : 'closesum',thClass : 'thbg-02',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C)'},
    {header : 'Revenue', field : 'closetaxnsum',thClass : 'thbg-03',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-1, Invoice - No)'},
    {header : 'Revenue', field : 'closetaxysum',thClass : 'thbg-04',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-2, Invoice - Yes)'},
    {header : 'Revenue Perf(%)', field : 'perf1',thClass:'qt thbg-04',class2:'th-rt',sfont:'th-sfont',sfontVal : '(C-2)'},

    {header : 'Revenue Perf(%)', field : 'perf2',thClass:'qt thbg-05',class2:'th-rt',sfont:'th-sfont',sfontVal : '(Close)'},
    {header : 'FCST', field : 'fcstabc',thClass : 'thbg-06',class2:'th-rt',sfont:'th-sfont',sfontVal : '(A,B,C)'},
    {header : 'FCST(%)', field : 'fcstper',thClass : 'thbg-06',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'FCST Delta to Prior Week',thClass : 'thbg-07', field : 'fcstabc_sub'},
    {header : 'GM', field : 'gmamt',thClass : 'thbg-08'},
    {header : 'GM(%)', field : 'gmamtper',thClass : 'thbg-08',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'GM Delta to Prior Week',thClass : 'thbg-07', field : 'gmamt_sub'},
    {header : 'To go', field : 'togofcstquota',thClass : 'thbg-09',class2:'th-rt',sfont:'th-sfont',sfontVal : '(FCST vs Quota)'},
    {header : 'Risk', field : 'riskvaluesum',thClass : 'thbg-10'},
    {header : 'Bridge', field : 'bridgevaluesum',thClass : 'thbg-10'},
    {header : 'FCST-Risk+Bridge', field : 'fcstriskbridgesum',thClass : 'thbg-11'},
    {header : 'FCST-Risk+Bridge(%)', field : 'fcstriskbridgeper',thClass:'tt thbg-11',class2:'th-rt',sfont:'th-sfont',sfontVal : '(%)'},
    {header : 'To go', field : 'togofcstriskbridgeper',thClass : 'thbg-12',class2:'th-rt',sfont:'th-sfont',sfontVal : '(FCST-Risk+Bridge vs Quota)'},
    {header : 'Upside', field : 'upsidevaluesum',thClass : 'thbg-10'},
    {header : 'Pipeline', field : 'pipelinevaluesum',thClass : 'thbg-13'},
    {header : 'Pipeline Size', field : 'pipelinesizeper',thClass : 'thbg-03'},
    {header : 'Pipeline Size per', field : 'pipelinesizeper',thClass : 'thbg-03'},
  ],
  value2 : []
})

const state = reactive({
  ceoList : [],

  searchParams : {
      fs_year : '',
      page_count : 1,
      unit_count : 100000,
      sales_ceo : ''
  },
  format:'yyyy',
  nodata: false
})

function getYearsList() {
  const prevYear = new Date().getFullYear() - 3;
  const currYear = new Date().getFullYear();
  for (let i = currYear; i >= prevYear; i--) {
    yearsList.value = [...yearsList.value, i];
  }
  state.searchParams.fs_year = yearsList.value[0];
}

async function search(){
  await getDataList();
  await getPerformanceTotal();
}

async function getDataList(){
  gridOptions.value.value =[]
  try{
    setIsLoading(true)
    let params = {
      employee_id  : state.searchParams.sales_ceo,
      fs_year : state.searchParams.fs_year
    }
    const res = await getPerformanceFCSTList(params)
    if(!res.rtn.length > 0){
      state.nodata = true;
    }else{
      state.nodata = false;
    }
    gridOptions.value.value = [...res.rtn].map((item)=>{

      if(item.class && !item.class_id){
        item.prod_nm = item.class
        item.type = 'sum'
      }else if(!item.class && !item.class_id){
        item.prod_nm = 'Total'
        item.type = 'total'
      }

      return item

    })

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

function getClassNm(data,index){
  let classNm = ''
  if(data.type === 'total'){
    classNm = 'total'
  }else if(data.type === 'sum'){
    classNm = 'sum'
  }

  switch(index){
    case 0 :
      if(classNm) {
        classNm = `${classNm} table-item text-start`
      }else{
        classNm = 'table-item'
      }
    break

    case 7 :
      if(classNm) {
        classNm = `${classNm} qt`
      }else{
        classNm = 'qt'
      }
    break

    case 8 :
      if(classNm) {
        classNm = `${classNm} qt`
      }else{
        classNm = 'qt'
      }
    break

    case 23 :
      if(classNm) {
        classNm = `${classNm} text-center`
      }else{
        classNm = 'text-center'
      }
    break
  }

  return classNm
}

function valueByClass(data,index){
  if(index !== 7 && index !== 8 && index !== 10 && index !== 19 && index !== (gridOptions.value.column.length-2)){
    if(index !== 0){
      if(isNaN(Number(data))) return

      if(Number(data) < 0) return 'text-b-rt'
    }
  }else{
    if(typeof data === 'string'){
       data = data.replaceAll('%','')
    }

    if(index === (gridOptions.value.column.length-2)){
      if(Number(data) >= 3){
        return 'ball-m'
      }else if(Number(data) >= 2){
        return 'ball-s'
      }else{
        return 'ball-b'
      }
    }


    if(Number(data) >= 100){
      return 'text-m-rt'
    }else if(Number(data) >= 90){
      return 'text-s-rt'
    }else{
      return 'text-b-rt'
    }
  }
}

function numberFormat(data,colIndex){
  let formatNum = data
  if(!isNaN(Number(data))){

    if(colIndex == gridOptions.value.column.length-1) {
      formatNum = Number(data).toFixed(1)
    }else{
      data = Math.floor(Number(data) * 100) / 100
      formatNum = common.checkNumberComma(data)
    }

  }
  return formatNum
}


const getSalesCeo = async () => {
      try {
        setIsLoading(true)
        state.ceoList = []


        if(['ADMIN', 'E'].includes(userStore.user.authGrpId)){
          const res = await getLoadUsers({employee_id : userStore.user.employeeId,auth_grp_id : userStore.user.authGrpId})
          state.ceoList.push({ text: '전체', value: '' })
          res.rtn.forEach(user => {
            state.ceoList.push({ text: user.user_nm, value: user.employee_id })
          })
          state.searchParams.sales_ceo = state.ceoList[0]?.value || ''
        }else{
          state.ceoList.push({ text: userStore.user.userNm, value: userStore.user.employeeId })
          state.searchParams.sales_ceo =  userStore.user.employeeId
        }



      } catch (err) {
        console.error(err);
        alert("영업대표 초기화 에러가 발생하였습니다.");
      } finally {
        setIsLoading(false)
      }
};

function excelDownload(){
  let fileNm = 'Yearly Performance FCST'
  let header = [...gridOptions.value.column]
  let dataList = [...gridOptions.value.value]
  excelManageRef.value.excelDownload(fileNm,header,dataList)
}


const getPerformanceTotal= async () =>{
  gridOptions.value.value2 =[]
  try{
    setIsLoading(true)

    const res = await getPerformanceTotalList(state.searchParams)

    gridOptions.value.value2 = [...res.rtn].map((item)=>{
      if(item.class && !item.class_id){
        item.prod_nm = item.class
        item.type = 'sum'
      }else if(!item.class && !item.class_id){
        item.prod_nm = 'Total'
        item.type = 'total'
      }

      return item

    })

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}
</script>
<style>

tr.row-spacer td {
  height: 20px;
  padding: 0;
  border: none;
  background-color: transparent;
}


tr.value2-row td {
  line-height: 0.5;

}

.p-splitter-gutter {
  background-color: #183462;
  margin-bottom: 20px;
  margin-top: 10px;
}
.p-splitter-gutter-handle{
  background-color: #183462;
}
</style>